import React from 'react';
import Layout from '../../components/Layout';
import Theme from './Theme';
import { getWorkspaceWidgetCount } from '../../data/models/Theme/themeJSONHelper';
import getMoreThemes from './more/getMoreThemes';
import { SITE_URL, canonicalUrl } from '../../utils/seo';

/**
 * Порог, ниже которого страницу темы не отдаём в индекс.
 *
 * Тема без описания и без единой установки — это одна картинка и заголовок,
 * то есть thin content. Таких страниц тысячи, и они разбавляют индекс.
 * Как только у темы появляется описание ИЛИ хоть одна установка, она
 * индексируется. @see docs/seo/SEO-AUDIT.md
 */
function isIndexable(theme) {
	const hasDescription =
		!!theme.description && theme.description.trim().length > 0;
	const hasInstalls = Number(theme.installs) > 0;

	return hasDescription || hasInstalls;
}

async function action({ params, fetch }) {
	const resp = await fetch('/graphql', {
		body: JSON.stringify({
			query: `{theme(id:"${params.id}"){id,title,description,installs,author,appJSON,status,access,workspace}}`,
		}),
	});
	const { data } = await resp.json();
	if (!data || !data.theme) throw new Error('Failed to load the theme.');

	const { theme } = data;
	const appJSON = JSON.parse(theme.appJSON);
	const workspaces = Object.keys(getWorkspaceWidgetCount(appJSON));
	const moreThemes = await getMoreThemes(fetch);

	const screenshot = `${SITE_URL}/screenshots/1200/${theme.id}-${theme.workspace}.jpg`;
	const widgetCount =
		appJSON.widgets && appJSON.widgets.widgets
			? appJSON.widgets.widgets.length
			: 0;

	const description =
		theme.description && theme.description.trim().length
			? theme.description.trim()
			: `"${theme.title}" is a New Tab Studio theme with ${widgetCount} widgets. ` +
			  'Install it on Chrome in one click and it becomes your new tab page — wallpaper, widgets and layout included.';

	return {
		chunks: ['theme'],
		title: `${theme.title} — New Tab Theme`,
		description,
		ogImage: screenshot,
		ogType: 'article',
		robots: isIndexable(theme) ? undefined : 'noindex, follow',
		jsonLd: [
			{
				'@context': 'https://schema.org',
				'@type': 'CreativeWork',
				'@id': `${canonicalUrl(`/theme/${theme.id}`)}#theme`,
				name: theme.title,
				description,
				url: canonicalUrl(`/theme/${theme.id}`),
				image: screenshot,
				creator: theme.author
					? { '@type': 'Person', name: theme.author }
					: undefined,
				isPartOf: { '@id': `${SITE_URL}/#website` },
			},
		],
		component: (
			<Layout>
				<Theme
					theme={theme}
					moreThemes={moreThemes}
					slug={params.id}
					appJSON={appJSON}
					workspaces={workspaces}
					data={data.news}
				/>
			</Layout>
		),
	};
}

export default action;
